export default __webpack_public_path__ + "static/media/operaImage.b8120ea7.png";